import { authState, signOut } from '../auth.js';
import { openAuthModal } from './AuthModal.js';

export function renderHeader() {
  const header = document.getElementById('main-header');
  if (!header) return;

  const user = authState.user;
  const profile = authState.profile;
  const displayName = profile?.display_name || user?.user_metadata?.display_name || user?.email?.split('@')[0] || 'Disciple';

  const hash = window.location.hash || '#home';
  const isHome = hash === '' || hash === '#' || hash === '#home';
  const isCourse = hash.startsWith('#course') || hash.startsWith('#lesson') || hash.startsWith('#join');
  const isVerses = hash === '#verses';
  const isStudies = hash.startsWith('#studies') || hash.startsWith('#study/');
  const isBlog = hash.startsWith('#blog');
  const isPrayer = hash === '#praytogether';
  const isDashboard = hash === '#dashboard';

  header.innerHTML = `
    <div class="header-container">
      <!-- Brand Logo & Name -->
      <a href="#home" class="brand-wrapper" id="nav-brand">
        <img src="/assets/logo.png" alt="Walk Together Ministries" class="brand-logo-img" />
        <div class="brand-title">
          <span>Walk Together</span>
          <span class="brand-sub">Ministries</span>
        </div>
      </a>

      <!-- Mobile Hamburger Button -->
      <button class="mobile-menu-toggle" id="mobile-menu-toggle-btn" aria-label="Toggle navigation menu" aria-expanded="false">
        <i class="fa-solid fa-bars"></i>
      </button>

      <!-- Main Navigation Menu -->
      <nav class="nav-links" id="main-nav-links">
        <a href="#home" class="nav-link-btn ${isHome ? 'active' : ''}" id="nav-link-home">
          Home
        </a>

        <!-- Discipleship Link -->
        <a href="#course" class="nav-link-btn ${isCourse ? 'active' : ''}" id="nav-link-course">
          Discipleship
        </a>

        <!-- Bible Studies Link -->
        <a href="#studies" class="nav-link-btn ${isStudies ? 'active' : ''}" id="nav-link-studies">
          Bible Studies
        </a>

        <!-- Blog Link -->
        <a href="#blog" class="nav-link-btn ${isBlog ? 'active' : ''}" id="nav-link-blog">
          Blog
        </a>

        <!-- Prayer App Link -->
        <a href="#praytogether" class="nav-link-btn ${isPrayer ? 'active' : ''}" id="nav-link-prayer">
          Prayer App
        </a>

        <!-- Nonprofit Care External Link -->
        <a href="https://walktogethercare.org" target="_blank" rel="noopener noreferrer" class="nav-link-btn nav-link-external" id="nav-link-care" title="Walk Together Care 501(c)(3) Nonprofit">
          Nonprofit Care <i class="fa-solid fa-arrow-up-right-from-square nav-ext-icon"></i>
        </a>

        ${user ? `
          <a href="#dashboard" class="nav-link-btn ${isDashboard ? 'active' : ''}" id="nav-link-dashboard">
            Dashboard
          </a>
        ` : ''}
      </nav>

      <!-- Header Actions (Theme Toggle & Auth) -->
      <div class="header-actions">
        <!-- Theme Toggle -->
        <button id="theme-toggle-btn" class="icon-btn" title="Toggle theme" aria-label="Toggle theme">
          <i class="fa-solid fa-sun"></i>
        </button>

        ${user ? `
          <div class="user-pill" id="user-profile-btn" title="Cohort: ${profile?.cohort_name || 'General'}">
            <div class="avatar-circle">
              ${displayName.charAt(0).toUpperCase()}
            </div>
            <span>${displayName}</span>
            <button id="signout-btn" class="icon-btn" style="width:24px; height:24px; margin-left:4px; border:none; background:transparent;" title="Sign out">
              <i class="fa-solid fa-right-from-bracket" style="font-size:0.75rem;"></i>
            </button>
          </div>
        ` : `
          <button id="open-auth-btn" class="btn-primary auth-btn-header">
            <i class="fa-solid fa-user-plus"></i> Sign In
          </button>
        `}
      </div>
    </div>
  `;

  // Attach event listeners
  const themeBtn = document.getElementById('theme-toggle-btn');
  if (themeBtn) {
    const isDark = document.body.classList.contains('theme-dark');
    themeBtn.innerHTML = isDark ? '<i class="fa-solid fa-sun"></i>' : '<i class="fa-solid fa-moon"></i>';
    themeBtn.onclick = () => {
      document.body.classList.toggle('theme-dark');
      document.body.classList.toggle('theme-light');
      const nowDark = document.body.classList.contains('theme-dark');
      themeBtn.innerHTML = nowDark ? '<i class="fa-solid fa-sun"></i>' : '<i class="fa-solid fa-moon"></i>';
      localStorage.setItem('wt_theme', nowDark ? 'dark' : 'light');
    };
  }

  // Mobile menu toggle
  const mobileToggle = document.getElementById('mobile-menu-toggle-btn');
  const navLinks = document.getElementById('main-nav-links');
  if (mobileToggle && navLinks) {
    mobileToggle.onclick = () => {
      const isOpen = navLinks.classList.toggle('mobile-open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
      mobileToggle.innerHTML = isOpen ? '<i class="fa-solid fa-xmark"></i>' : '<i class="fa-solid fa-bars"></i>';
    };

    // Close mobile nav when clicking a link
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('mobile-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.innerHTML = '<i class="fa-solid fa-bars"></i>';
      });
    });
  }

  const openAuth = document.getElementById('open-auth-btn');
  if (openAuth) {
    openAuth.onclick = () => openAuthModal('signin');
  }

  const signOutBtn = document.getElementById('signout-btn');
  if (signOutBtn) {
    signOutBtn.onclick = async (e) => {
      e.stopPropagation();
      await signOut();
      renderHeader();
    };
  }

  const userProfileBtn = document.getElementById('user-profile-btn');
  if (userProfileBtn) {
    userProfileBtn.onclick = () => {
      window.location.hash = '#dashboard';
    };
  }
}
